import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { AudioFormat } from 'constants/enums'

interface ProfileState {
  profile: Record<string, unknown>
  mergeEmailStarted: boolean
  mergeEmailError: string
  splitEmailStarted: boolean
  splitEmailError: string
}

const initialState: ProfileState = {
  profile: { format: AudioFormat.mp3.value },
  mergeEmailStarted: false,
  mergeEmailError: '',
  splitEmailStarted: false,
  splitEmailError: '',
}

const profileSlice = createSlice({
  name: 'profile',
  initialState,
  reducers: {
    getProfile: {
      prepare(id: string) {
        return { payload: id }
      },
      reducer() {
        // no-op, used for thunks
      },
    },
    didGetProfile: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.profile = action.payload
    },
    didUpdateProfileSuccess: (state, action: PayloadAction<Record<string, unknown>>) => {
      state.profile = action.payload
    },
    toggleMergeEmailStarted: (state, action: PayloadAction<boolean>) => {
      state.mergeEmailStarted = action.payload
    },
    setMergeEmailError: (state, action: PayloadAction<string>) => {
      state.mergeEmailError = action.payload
    },
    toggleSplitEmailStarted: (state, action: PayloadAction<boolean>) => {
      state.splitEmailStarted = action.payload
    },
    setSplitEmailError: (state, action: PayloadAction<string>) => {
      state.splitEmailError = action.payload
    },
    reset: () => initialState,
  },
})

export const profileActions = profileSlice.actions
export const profileReducer = profileSlice.reducer
export default profileActions
